import {
  GET_LIST_DANHSACHTAISAN,
  GET_LIST_DANHSACHTAISAN_SUCCESS,
  GET_LIST_DANHSACHTAISAN_FAILURE,
} from "actions/DanhSachTaiSan/actionTypes";

const initialState = {
  getListDanhSachTaiSanLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListDanhSachTaiSan = (state, action) => ({
  ...state,
  getListDanhSachTaiSanLoading: true,
});

const getListDanhSachTaiSanSuccess = (state, action) => {
  return {
    ...state,
    getListDanhSachTaiSanLoading: false,
    objList: action.payload,
  };
};

const getListDanhSachTaiSanFailed = (state, action) => ({
  ...state,
  getListDanhSachTaiSanLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHTAISAN:
      return getListDanhSachTaiSan(state, action);
    case GET_LIST_DANHSACHTAISAN_SUCCESS:
      return getListDanhSachTaiSanSuccess(state, action);
    case GET_LIST_DANHSACHTAISAN_FAILURE:
      return getListDanhSachTaiSanFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
